<template>
  <b-card class="rounded-xl">
    <modal :show.sync="editModal" header-classes="bg-primary p-3">
      <h6 slot="header" class="modal-title text-white font-semibold pt-1">
        Add Tags
      </h6>
      <EditTagsDetail />
      <template slot="footer">
        <base-button type="primary">ADD</base-button>
        <base-button type="secondary" class="ml-auto" @click="editModal = false"
          >CLOSE</base-button
        >
      </template>
    </modal>
    <AddTagsSidebar
      :isSidebarActive="openAddBannerSidebar"
      @closeSidebar="toggleAddBannerSidebar"
    />
    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-semibold">Tags</h2>

        <small class="text-muted">Manage your tags efficiently here. </small>
      </div>
      <base-button
        type="primary"
        class="px-8"
        @click="openAddBannerSidebar = true"
      >
        Add Tags
      </base-button>
    </div>
    <!-- <b-input-group class="mt-12">
      <b-form-input
        class="border-none shadow-lg"
        type="text"
        min="0.00"
        placeholder="Enter Search...."
      ></b-form-input>

      <b-input-group-append>
        <b-button
          variant="white"
          class="flex items-center shadow-lg"
          aria-label="search"
        >
          <feather-icon
            class=" cursor-pointer  mr-2"
            icon="SearchIcon"
            svgClasses="w-4 h-4"
          ></feather-icon>
        </b-button>
      </b-input-group-append>
    </b-input-group> -->
    <UsersTable />
  </b-card>
</template>
<script>
import "../../scss/Index.scss";

import EditTagsDetail from "./components/EditTagsDetail";
import AddTagsSidebar from "./components/AddTagsSidebar";
import UsersTable from "./components/UsersTable";

export default {
  name: "light-table",
  components: {
    EditTagsDetail,
    AddTagsSidebar,
    UsersTable,
  },
  data() {
    return {
      currentPage: 1,
      editModal: false,
      openAddBannerSidebar: false,
    };
  },
  methods: {
    addBanner() {
      this.toggleAddBannerSidebar(true);
    },
    toggleAddBannerSidebar(val = false) {
      this.openAddBannerSidebar = val;
    },
  },
};
</script>
